// 全てのPageがBaseFrameに包まれている。
export default function BaseFrame(props) {
    const { children } = props;
    return children;
}
